(function () {
  if (window.__embalagemCartLoaded) {
    return;
  }
  window.__embalagemCartLoaded = true;

  const PRODUCT_HANDLE = "embalagem-retornavel";
  const SYNC_HEADER = "X-Embalagem-Sync";
  const PACK_TAG_ORDER = [
    "12_400ml",
    "8_400ml",
    "4_400ml",
    "20_250ml",
    "10_250ml",
  ];
  const TITLE_BY_TAG = {
    "12_400ml": "Pack 12 · 400ml",
    "8_400ml": "Pack 8 · 400ml",
    "4_400ml": "Pack 4 · 400ml",
    "20_250ml": "Pack 20 · 250ml",
    "10_250ml": "Pack 10 · 250ml",
  };
  const FALLBACK_SECTIONS = [
    "cart-drawer",
    "cart-icon-bubble",
    "cart-live-region-text",
    "main-cart-items",
    "main-cart-footer",
  ];

  let syncing = false;
  let queued = false;
  let debounceTimer = null;
  let pubSubHooked = false;
  const tagCache = new Map();

  function syncHeaders(extra) {
    const headers = Object.assign({ "Content-Type": "application/json" }, extra || {});
    headers[SYNC_HEADER] = "1";
    return headers;
  }

  async function getJson(url, options) {
    const next = Object.assign({ credentials: "same-origin" }, options || {});
    next.headers = syncHeaders(next.headers);
    const response = await fetch(url, next);
    if (!response.ok) {
      throw new Error(url + " " + response.status);
    }
    return response.json();
  }

  async function getCart() {
    return getJson("/cart.js");
  }

  async function getProduct(handle) {
    try {
      return await getJson("/products/" + handle + ".js");
    } catch (error) {
      return null;
    }
  }

  async function getTags(handle) {
    if (tagCache.has(handle)) {
      return tagCache.get(handle);
    }
    const product = await getProduct(handle);
    const tags = product
      ? String(product.tags || "")
          .split(",")
          .map(function (tag) {
            return tag.trim();
          })
          .filter(Boolean)
      : [];
    tagCache.set(handle, tags);
    return tags;
  }

  function packTagFromTags(tags) {
    for (let i = 0; i < PACK_TAG_ORDER.length; i += 1) {
      const tag = PACK_TAG_ORDER[i];
      if (tags.indexOf(tag) !== -1) {
        return tag;
      }
    }
    return null;
  }

  function variantIdForTag(embalagem, tag) {
    const title = TITLE_BY_TAG[tag];
    if (!title || !embalagem || !embalagem.variants) {
      return null;
    }
    const variant = embalagem.variants.find(function (item) {
      return item.title === title || item.option1 === title;
    });
    return variant ? variant.id : null;
  }

  async function neededQuantities(cart, embalagem) {
    const needed = {};
    for (let i = 0; i < cart.items.length; i += 1) {
      const item = cart.items[i];
      if (item.handle === PRODUCT_HANDLE) {
        continue;
      }
      const tags = await getTags(item.handle);
      const tag = packTagFromTags(tags);
      if (!tag) {
        continue;
      }
      const variantId = variantIdForTag(embalagem, tag);
      if (!variantId) {
        continue;
      }
      const key = String(variantId);
      needed[key] = (needed[key] || 0) + item.quantity;
    }
    return needed;
  }

  function isFeeNode(node) {
    if (!node || !node.querySelector) {
      return false;
    }
    if (node.hasAttribute && node.hasAttribute("data-embalagem-retornavel")) {
      return true;
    }
    return !!node.querySelector('a[href*="' + PRODUCT_HANDLE + '"]');
  }

  function hideEmbalagemControls() {
    const candidates = document.querySelectorAll(
      "tr.cart-item, tr.cart-items__table-row, tr[data-key], .cart-item, cart-drawer-items .cart-item, cart-items-component tr"
    );
    candidates.forEach(function (row) {
      if (!isFeeNode(row)) {
        return;
      }
      row.setAttribute("data-embalagem-retornavel", "true");
      row.querySelectorAll("cart-remove-button, .cart-items__remove").forEach(function (el) {
        el.hidden = true;
        el.setAttribute("aria-hidden", "true");
        el.style.display = "none";
      });
      row.querySelectorAll(
        "quantity-input, quantity-selector-component, .quantity-selector, .quantity"
      ).forEach(function (el) {
        el.style.display = "none";
      });
    });
  }

  document.addEventListener(
    "click",
    function (event) {
      const remove = event.target.closest("cart-remove-button, .cart-items__remove");
      if (!remove) {
        return;
      }
      const row = remove.closest("tr, .cart-item");
      if (!isFeeNode(row)) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      hideEmbalagemControls();
    },
    true
  );

  function collectSectionIds() {
    const ids = [];
    function add(id) {
      if (id && ids.indexOf(id) === -1) {
        ids.push(id);
      }
    }
    document.querySelectorAll("cart-items-component[data-section-id]").forEach(function (el) {
      add(el.getAttribute("data-section-id"));
    });
    ["cart-drawer", "cart-items", "cart-notification"].forEach(function (tag) {
      const el = document.querySelector(tag);
      if (!el || typeof el.getSectionsToRender !== "function") {
        return;
      }
      el.getSectionsToRender().forEach(function (section) {
        add(section.section || section.id);
      });
    });
    FALLBACK_SECTIONS.forEach(function (id) {
      const byId = typeof document.getElementById === "function" ? document.getElementById.bind(document) : null;
      if (
        (byId && (byId(id) || byId("shopify-section-" + id))) ||
        document.querySelector("[id^='shopify-section-" + id + "']")
      ) {
        add(id);
      }
    });
    if (ids.length === 0) {
      FALLBACK_SECTIONS.forEach(add);
    }
    return ids;
  }

  function getSectionInnerHTML(html, selector) {
    const parsed = new DOMParser().parseFromString(html, "text/html");
    const node = parsed.querySelector(selector || ".shopify-section") || parsed.body;
    return node ? node.innerHTML : html;
  }

  function applySections(sections) {
    if (!sections) {
      return;
    }
    const drawer = document.querySelector("cart-drawer");
    const items = document.querySelector("cart-items");
    const notification = document.querySelector("cart-notification");

    if (drawer && typeof drawer.renderContents === "function") {
      try {
        drawer.renderContents({ sections: sections });
      } catch (error) {
        /* Dawn variants differ slightly */
      }
    }
    if (items && typeof items.getSectionsToRender === "function") {
      try {
        items.getSectionsToRender().forEach(function (section) {
          const container = document.getElementById(section.id);
          if (!container) {
            return;
          }
          const html = sections[section.section] || sections[section.id];
          if (!html) {
            return;
          }
          const target = section.selector
            ? container.querySelector(section.selector) || container
            : container;
          target.innerHTML = getSectionInnerHTML(html, section.selector);
        });
      } catch (error) {
        /* cart page optional */
      }
    }
    if (notification && typeof notification.renderContents === "function") {
      try {
        notification.renderContents({ sections: sections });
      } catch (error) {
        /* optional */
      }
    }

    Object.keys(sections).forEach(function (id) {
      const html = sections[id];
      if (!html) {
        return;
      }
      const bubble = document.getElementById("shopify-section-" + id) || document.getElementById(id);
      if (!bubble) {
        return;
      }
      if (id === "cart-icon-bubble" || id === "cart-live-region-text") {
        bubble.innerHTML = getSectionInnerHTML(html);
      }
    });
  }

  function notifyThemeCart(sections) {
    const detail = {
      source: "embalagem-cart",
      data: {
        source: "embalagem-cart",
        sections: sections || {},
      },
    };
    document.dispatchEvent(
      new CustomEvent("cart:update", {
        bubbles: true,
        detail: detail,
      })
    );
    document.dispatchEvent(
      new CustomEvent("cart:refresh", {
        bubbles: true,
        detail: detail,
      })
    );
  }

  async function refreshCartUi() {
    let sections = {};
    try {
      const ids = collectSectionIds();
      if (ids.length > 0) {
        const pathname = window.location.pathname || "/";
        sections = await getJson(pathname + "?sections=" + encodeURIComponent(ids.join(",")));
        applySections(sections);
      }
    } catch (error) {
      console.warn("[embalagem-cart] sections", error);
    }
    notifyThemeCart(sections);
    hideEmbalagemControls();
    if (typeof requestAnimationFrame === "function") {
      requestAnimationFrame(hideEmbalagemControls);
    }
  }

  async function syncCart() {
    if (syncing) {
      queued = true;
      return;
    }
    syncing = true;
    try {
      const cart = await getCart();
      const embalagem = await getProduct(PRODUCT_HANDLE);
      if (!embalagem) {
        return;
      }
      const needed = await neededQuantities(cart, embalagem);
      const existing = {};
      cart.items.forEach(function (item) {
        if (item.handle === PRODUCT_HANDLE) {
          existing[String(item.variant_id)] = item;
        }
      });

      const updates = {};
      const toAdd = [];

      Object.keys(needed).forEach(function (variantId) {
        const quantity = needed[variantId];
        const line = existing[variantId];
        if (!line) {
          toAdd.push({ id: Number(variantId), quantity: quantity });
        } else if (line.quantity !== quantity) {
          updates[line.key] = quantity;
        }
      });

      Object.keys(existing).forEach(function (variantId) {
        if (!needed[variantId]) {
          updates[existing[variantId].key] = 0;
        }
      });

      let changed = false;
      if (Object.keys(updates).length > 0) {
        await getJson("/cart/update.js", {
          method: "POST",
          body: JSON.stringify({ updates: updates }),
        });
        changed = true;
      }

      if (toAdd.length > 0) {
        await getJson("/cart/add.js", {
          method: "POST",
          body: JSON.stringify({
            items: toAdd.map(function (item) {
              return {
                id: item.id,
                quantity: item.quantity,
                properties: { _embalagem_retornavel: "1" },
              };
            }),
          }),
        });
        changed = true;
      }

      if (changed) {
        await refreshCartUi();
      } else {
        hideEmbalagemControls();
      }
    } catch (error) {
      console.warn("[embalagem-cart]", error);
    } finally {
      syncing = false;
      if (queued) {
        queued = false;
        syncCart();
      }
    }
  }

  function scheduleSync() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      syncCart();
    }, 120);
  }

  function isOurRequest(input, init) {
    const headers = init && init.headers;
    if (headers) {
      if (typeof Headers !== "undefined" && headers instanceof Headers) {
        if (headers.get(SYNC_HEADER) === "1") {
          return true;
        }
      } else if (Array.isArray(headers)) {
        if (
          headers.some(function (pair) {
            return String(pair[0]).toLowerCase() === SYNC_HEADER.toLowerCase() && String(pair[1]) === "1";
          })
        ) {
          return true;
        }
      } else if (headers[SYNC_HEADER] === "1" || headers["x-embalagem-sync"] === "1") {
        return true;
      }
    }
    if (typeof Request !== "undefined" && input instanceof Request) {
      return input.headers.get(SYNC_HEADER) === "1";
    }
    return false;
  }

  function cartMutationUrl(url) {
    try {
      const raw = typeof url === "string" ? url : url && url.url;
      if (!raw) {
        return false;
      }
      const path = new URL(raw, window.location.origin).pathname;
      return /\/cart\/(add|change|update|clear)(\.js)?$/i.test(path);
    } catch (error) {
      return false;
    }
  }

  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const mutating = cartMutationUrl(input);
    const ours = isOurRequest(input, init);
    return originalFetch.apply(this, arguments).then(function (response) {
      if (mutating && !ours && response.ok) {
        scheduleSync();
      }
      return response;
    });
  };

  if (window.XMLHttpRequest) {
    const originalOpen = XMLHttpRequest.prototype.open;
    const originalSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._embalagemCartUrl = url;
      return originalOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      const xhr = this;
      if (cartMutationUrl(xhr._embalagemCartUrl)) {
        xhr.addEventListener("load", function () {
          if (xhr.status >= 200 && xhr.status < 300) {
            scheduleSync();
          }
        });
      }
      return originalSend.apply(this, arguments);
    };
  }

  document.addEventListener("cart:update", function (event) {
    const source =
      (event.detail && event.detail.data && event.detail.data.source) ||
      (event.detail && event.detail.source);
    if (source === "embalagem-cart") {
      hideEmbalagemControls();
      return;
    }
    scheduleSync();
  });

  document.addEventListener("shopify:cart:lines-update", function (event) {
    if (event.promise && typeof event.promise.then === "function") {
      event.promise.then(function () {
        scheduleSync();
      }).catch(function () {});
      return;
    }
    scheduleSync();
  });

  function hookPubSub() {
    if (pubSubHooked) {
      return true;
    }
    if (typeof window.subscribe !== "function" || !window.PUB_SUB_EVENTS || !window.PUB_SUB_EVENTS.cartUpdate) {
      return false;
    }
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (event && event.source === "embalagem-cart") {
        return;
      }
      scheduleSync();
    });
    pubSubHooked = true;
    return true;
  }

  let pubSubTries = 0;
  function waitForPubSub() {
    if (hookPubSub() || pubSubTries > 40) {
      return;
    }
    pubSubTries += 1;
    setTimeout(waitForPubSub, 50);
  }

  const cartUiObserver = new MutationObserver(function () {
    hideEmbalagemControls();
  });
  function observeCartUi() {
    document
      .querySelectorAll(
        "cart-drawer, #CartDrawer, cart-items, cart-items-component, #main-cart-items, cart-notification, .cart-drawer"
      )
      .forEach(function (root) {
        cartUiObserver.observe(root, { childList: true, subtree: true });
      });
  }

  function onReady() {
    hideEmbalagemControls();
    observeCartUi();
    waitForPubSub();
    syncCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }
})();
